import React, { useContext, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

import { DomainObject, Params, Result } from 'types';
import { PageKey } from 'enums';
import { Table } from 'components/table/table';
import {
  BreadcrumbsCtx,
  initialBreadcrumbs,
} from 'components/portfolio/breadcrumbs-ctx';
import { useTableHook } from 'components/table/table-hook';
import {
  AdditionalRowComponentProps,
  TableColumn,
} from 'components/table/table-types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      margin: theme.spacing(2),
    },
    error: {
      fontWeight: 700,
      marginLeft: 20,
    },
    historyDetailField: {
      display: 'flex',
      padding: '2px 5px',
      alignItems: 'center',
    },
    historyDetailFieldLabel: {
      width: 110,
      fontWeight: 500,
      textAlign: 'right',
      marginRight: 20,
    },
    wrapper: {
      backgroundColor: '#FAFAFA',
      minHeight: 100,
      padding: '0px 20px',
    },
  })
);

interface LentTableProps<T> {
  title: string;
  pageKey: PageKey;
  columns: TableColumn[];
  params?: Params;
  fetchFunction: (params: Params) => Promise<Result<T>>;

  DetailComponent?: (props: AdditionalRowComponentProps<T>) => JSX.Element;
}

export function LentTable<T extends DomainObject>({
  pageKey,
  title,
  columns,
  params,
  fetchFunction,
  DetailComponent,
}: LentTableProps<T>) {
  const classes = useStyles();

  const { setBreadcrumbs } = useContext(BreadcrumbsCtx);
  const tableProps = useTableHook<T>({ fetchFunction, params });

  useEffect(() => {
    setBreadcrumbs([
      ...initialBreadcrumbs.breadcrumbs,
      { key: pageKey, title },
    ]);
  }, [pageKey, setBreadcrumbs, title]);

  return (
    <>
      <Grid container>
        <Grid item xs={12} className={classes.table}>
          <Table<T>
            {...tableProps}
            // rows={[]}
            columns={columns}
            expandableRows={!!DetailComponent}
            AdditionalRowComponent={DetailComponent}
          />
        </Grid>
      </Grid>
    </>
  );
}
